
import { defineComponent, onMounted, ref, watch } from "vue";
import { statusColor, translate } from "@/core/services/HelpersFun";
import ApiService from "@/core/services/ApiService";
import { ElNotification } from "element-plus";
import { useStore } from "vuex";
import { Mutations } from "@/store/enums/StoreEnums";
export default defineComponent({
  name: "show-user-answer-to-body-modal",
  components: {},
  emits: ["refreshTickets"],
  props: {
    session_key: {
      type: String,
      default: null,
    },
  },
  setup(props) {
    const loading = ref(true);
    const list = ref();
    const store = useStore();
    const getAnswer = () => {
      loading.value = true;
      ApiService.get(
        `/questionnaires/user-answers?session_key=${props.session_key}`
      )
        .then(({ data }) => {
          list.value = data.data.user_answers;
          loading.value = false;
        })
        .catch((e) => {
          loading.value = false;
          store.commit(Mutations.SET_ERROR, e.response);
          ElNotification({
            title: "خطا",
            message: "خطا در ایجاد سوال پرسشنامه",
            type: "error",
          });
        });
    };

    watch(props, () => {
      getAnswer();
    });

    return {
      loading,
      statusColor,
      translate,
      list,
    };
  },
});
